import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { animated, useSpring } from 'react-spring';
import { useSelector } from 'react-redux';

import BoardPodiums from './BoardPodiums';
import BoardTableWrapper from './BoardTableWrapper';

import Title from '../../../shared/_TBComponents/Title';
import useWindowSize from '../../../shared/hooks/useWindowSize';

const BlankBoardContainer = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

// paddingTop gives the podium ribbon (position:absolute; top:-30px) room to render
// inside the scroll container's clipping boundary before scrolling begins.
const scrollContainerStyle = {
  overflow: 'scroll',
  flexGrow: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '36px',
};

const BoardData = ({
  activeBoards,
  id,
}) => {
  const leaderboardData = useSelector(
    (state) => state.leaderboard.data.leaderboards[id].leaderboardData,
  );

  const windowSize = useWindowSize();

  const scrollContainerRef = useRef(null);
  const podiumsRef = useRef(null);
  const [scrollAmount, setScrollAmount] = useState(0);
  const scrollAnimation = useSpring({ scroll: scrollAmount, from: { scroll: 0 } });

  return (
    leaderboardData.length !== 0 ? (
      <animated.div
        ref={scrollContainerRef}
        scrollTop={scrollAnimation.scroll}
        style={scrollContainerStyle}
      >
        <div ref={podiumsRef}>
          <BoardPodiums
            activeBoards={activeBoards}
            leaderboardData={leaderboardData}
            windowSize={windowSize}
          />
        </div>
        <BoardTableWrapper
          activeBoards={activeBoards}
          id={id}
          windowSize={windowSize}
          scrollAmount={scrollAmount}
          setScrollAmount={setScrollAmount}
          scrollContainerRef={scrollContainerRef}
          podiumsRef={podiumsRef}
        />
      </animated.div>
    ) : (
      <BlankBoardContainer>
        <Title
          icon='trophy'
        >
          No Records Found
        </Title>
      </BlankBoardContainer>
    )
  );
};

BoardData.propTypes = {
  activeBoards: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
};

export default BoardData;
